var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 10,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.257 9.912.987 5.725C.732 5.486.532 5.307.532 5s.17-.474.455-.725L6.257.088a.83.83 0 0 1 .806.033.82.82 0 0 1 .405.691v8.376a.82.82 0 0 1-.406.69.83.83 0 0 1-.805.034"
})));
export { SvgBack as ReactComponent };
export default __webpack_public_path__ + "Back.dbd0744a.svg";